import React from 'react';
import IQuestionMark from './IQuestionMark';
import * as style from './QuestionMarkStyle.module.scss'

const QuestionMark: React.FunctionComponent<IQuestionMark> = (props) => {
  const classNames = [
    props.isWhite ? style.questionMarkWhite : '',
    props.isSmall ? style.questionMarkSmall : '',
  ];

  const styles = {
    marginLeft: props.marginLeft || 'inherit',
  };

  return (
    <span className={[style.questionMark, ...classNames].join(' ')} style={styles} />
  );
};

export default QuestionMark;
